import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';

import { useLayoutContext } from '@ott/layout-context';
import { l10n, langCode } from '@ott/l10n';
import Modal from '@ott/modal';

import { checkCaptcha } from './redux/actions';
import captchaSelector from './redux/selector';
import { registerDispatch } from './dispatch';

import { RECAPTCHA_KEY, CONTAINER_PREFIX } from '../constants';

import styles from './Captcha.scss';

const Captcha: React.FC = () => {
  const dispatch = useDispatch();
  const { isCaptchaShown, mountContainer } = useSelector(captchaSelector);
  const { isMobileLayout } = useLayoutContext();

  useEffect(() => {
    /**
     * superagent должен уметь диспатчить экшоны, однако чтобы не привязывать superagent к redux,
     * dispatch пишется в переменную (см. src/utilities/superagent/src/limiter/dispatch.ts)
     *
     * С помощью функции registerDispatch происходит запись. Затем для использвоания dispatch
     * нужно его просто импортировать.
     *
     * Можно было бы вызывать registerDispatch(store.dispatch) сразу после createStore в коде продукта, но
     *  - это требует лишних телодвижений и знания тонкостей работы лимитера
     *  - такой ранний вызов не имеет смысла - мы все равно не сможем отобразить капчу, пока этот компонент не отрендерится
     */
    registerDispatch(dispatch);
  }, []);

  const handleRecaptchaChange = useCallback(
    (token: string | null) => {
      dispatch(checkCaptcha(token));
    },
    [dispatch]
  );

  const captchaNode = isCaptchaShown && (
    // @ts-ignore
    <ReCAPTCHA
      hl={langCode}
      sitekey={RECAPTCHA_KEY}
      onChange={handleRecaptchaChange}
      size={isMobileLayout ? 'compact' : 'normal'}
    />
  );

  if (isCaptchaShown && mountContainer) {
    const container = document.querySelector(`#${CONTAINER_PREFIX}${mountContainer}`);

    if (container) {
      return createPortal(captchaNode, container);
    }
  }

  return (
    <Modal
      isOpen={isCaptchaShown}
      preventUserClose={true}
      hideClose={true}
      closeOnOutsideClick={false}
    >
      <div className={styles.container}>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: l10n('captcha.text') }} />
        {captchaNode}
      </div>
    </Modal>
  );
};

export default React.memo(Captcha);
